import React from 'react';
import { ReactNode } from 'react';

import clsx from 'clsx';

import styles from './Table.module.scss';

export interface TableProps {
  children: ReactNode;
  className?: string;
}

const Table = ({ children, className }: TableProps) => {
  return <div className={clsx(styles.table, className)}>{children}</div>;
};

export default Table;
